export default {
    homePage: '/',
    aboutPage: '/about',
    contactPage: '/contact',
    joinPage: '/join',
}